<template>
  <v-row align="stretch">
    <v-col cols="7" class="d-flex">
      <apexchart class="flex-grow-1" type="bar" height="100%" :options="confGraficaPiezas"
        :series="seriesGraficaPiezas" />
    </v-col>
    <v-col cols="3" class="d-flex">
      <v-card>
        <div class="d-flex justify-center">
          <v-card-title>Piezas producidas por calidad</v-card-title>
        </div>
        <div>
          <v-tabs v-model="tab" v-show="false">
            <v-tab v-for="(label, i) in ['Item One', 'Item Two', 'Item Three']" :key="i">
              {{ label }}
            </v-tab>
          </v-tabs>
          <v-tabs-items v-model="tab">
            <v-tab-item :key="0">
              <apexchart type="pie" width="100%" :options="chartPastel" :series="pastel"></apexchart>
              <v-card-text class="d-flex justify-center">
                Lado Derecho
              </v-card-text>
            </v-tab-item>
            <v-tab-item :key="1">
              <apexchart type="pie" width="100%" :options="chartPastel" :series="pastelIzq"></apexchart>
              <v-card-text class="d-flex justify-center">
                Lado Izquierdo
              </v-card-text>
            </v-tab-item>
            <v-tab-item :key="2">
              <apexchart type="pie" width="100%" :options="chartPastel" :series="pastelTotal"></apexchart>
              <v-card-text class="d-flex justify-center">
                Resumen
              </v-card-text>
            </v-tab-item>
          </v-tabs-items>
        </div>
      </v-card>
    </v-col>
    <v-col cols="2" class="d-flex">
      <v-card flat>
        <v-tabs v-model="tab1" v-show="false">
          <v-tab v-for="(label, i) in ['Item One', 'Item Two', 'Item Three']" :key="i">
            {{ label }}
          </v-tab>
        </v-tabs>
        <v-tabs-items v-model="tab1">
          <v-tab-item :key="0" color="error">
            <v-card color="error" dark>
              <v-card-title class="text-center"
                style="white-space: normal; word-break: normal; overflow-wrap: break-word;">
                Piezas OK Producidas (Derecha) Totales
              </v-card-title>
              <div class="d-flex justify-center align-center text-h5 font-weight-bold"
                style="width: 100%; height: 70px;">
                {{ value.pzaRealizadas }} / {{ value.pzaTeoricas }}
              </div>
            </v-card>
            <v-card color="primary" class="mt-5" dark>
              <div class="d-flex justify-center align-center">
                <v-card-title class="text-center"
                  style="white-space: normal; word-break: normal; overflow-wrap: break-word;">
                  Piezas Esperadas por hora
                </v-card-title>
              </div>
              <div class="d-flex justify-center align-center text-h5 font-weight-bold"
                style="width: 100%; height: 70px;">
                {{ value.horas[0].pzaTeoricas }}
              </div>
            </v-card>
            <v-card color="success" class="mt-5" dark>
              <div class="d-flex justify-center align-center">
                <v-card-title class="text-center"
                  style="white-space: normal; word-break: normal; overflow-wrap: break-word;">
                  Piezas en el periodo
                  <br>
                  <!-- {{ horaActualData }} -->
                </v-card-title>
              </div>
              <div class="d-flex justify-center align-center text-h5 font-weight-bold"
                style="width: 100%; height: 70px;">
                {{ ratioActual }}
              </div>
            </v-card>
          </v-tab-item>
          <v-tab-item :key="1">
            <v-card color="error" dark>
              <v-card-title class="text-center"
                style="white-space: normal; word-break: normal; overflow-wrap: break-word;">
                Piezas OK Producidas (Izquierda) Totales
              </v-card-title>
              <div class="d-flex justify-center align-center text-h5 font-weight-bold"
                style="width: 100%; height: 70px;">
                173/430
              </div>
            </v-card>
            <v-card color="primary" class="mt-5" dark>
              <div class="d-flex justify-center align-center">
                <v-card-title class="text-center"
                  style="white-space: normal; word-break: normal; overflow-wrap: break-word;">
                  Piezas Esperadas por hora
                </v-card-title>
              </div>
              <div class="d-flex justify-center align-center text-h5 font-weight-bold"
                style="width: 100%; height: 70px;">
                173
              </div>
            </v-card>
            <v-card color="success" class="mt-5" dark>
              <div class="d-flex justify-center align-center">
                <v-card-title class="text-center"
                  style="white-space: normal; word-break: normal; overflow-wrap: break-word;">
                  Piezas en el periodo
                  <br>
                  (16:00 17:00)
                </v-card-title>
              </div>
              <div class="d-flex justify-center align-center text-h5 font-weight-bold"
                style="width: 100%; height: 70px;">
                10/20
              </div>
            </v-card>
          </v-tab-item>
          <v-tab-item :key="2">
            <v-card color="error" dark>
              <v-card-title class="text-center"
                style="white-space: normal; word-break: normal; overflow-wrap: break-word;">
                Piezas OK Producidas (Resumen) Totales
              </v-card-title>
              <div class="d-flex justify-center align-center text-h5 font-weight-bold"
                style="width: 100%; height: 70px;">
                173/430
              </div>
            </v-card>
            <v-card color="primary" class="mt-5" dark>
              <div class="d-flex justify-center align-center">
                <v-card-title class="text-center"
                  style="white-space: normal; word-break: normal; overflow-wrap: break-word;">
                  Piezas Esperadas por hora
                </v-card-title>
              </div>
              <div class="d-flex justify-center align-center text-h5 font-weight-bold"
                style="width: 100%; height: 70px;">
                173
              </div>
            </v-card>
            <v-card color="success" class="mt-5" dark>
              <div class="d-flex justify-center align-center">
                <v-card-title class="text-center"
                  style="white-space: normal; word-break: normal; overflow-wrap: break-word;">
                  Piezas en el periodo
                  <br>
                  (16:00 17:00)
                </v-card-title>
              </div>
              <div class="d-flex justify-center align-center text-h5 font-weight-bold"
                style="width: 100%; height: 70px;">
                10/20
              </div>
            </v-card>
          </v-tab-item>
        </v-tabs-items>
      </v-card>
    </v-col>
  </v-row>
</template>

<script>
import VueApexCharts from 'vue-apexcharts'

export default {
  props: {
    value: Object,
  },
  components: {
    apexchart: VueApexCharts,
  },
  data() {
    return {
      tab: 0,
      tab1: 0,

      // series1: [44, 55, 13],
      chartPastel: {
        chart: {
          width: 380,
          type: 'pie',
        },
        labels: ['Buenas', 'Retrabajo', 'Scrap'],
        responsive: [{
          breakpoint: 480,
          options: {
            chart: {
              width: 200
            },
          }
        }],
        legend: {
          position: 'bottom',
          horizontalAlign: 'center',
        }
      },
    }
  },
  methods: {
    iniciarRotacionTabs() {
      setInterval(() => {
        this.tab = this.tab == 2 ? this.tab = 0 : this.tab + 1;
        this.tab1 = this.tab1 == 2 ? this.tab1 = 0 : this.tab1 + 1;
      }, 5000);
    }
  },
  mounted() {
    this.iniciarRotacionTabs();
  },
  computed: {
    horaActualData() {
      const horas = this.value?.horas || [];
      if (!horas.length) return null;

      // formatear fecha local a "YYYY-MM-DD"
      const d = new Date();
      const pad = n => String(n).padStart(2, '0');
      // const today = `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}`;
      const today = "2025-07-10"
      console.log(today)

      // minutos desde la medianoche de la hora actual
      const ahoraMin = d.getHours() * 60 + d.getMinutes();

      return horas.find(h => {
        // asegurar que sea la fecha involucrada de hoy
        if (h.fechaInvolucrada !== today) return false;

        // parsear "HH:mm" a minutos
        const [sh, sm] = h.desdeHora.split(':').map(Number);
        const [eh, em] = h.hastaHora.split(':').map(Number);
        const inicio = sh * 60 + sm;
        const fin = eh * 60 + em;

        return ahoraMin >= inicio && ahoraMin < fin;
      }) || null;
    },
    // 2) A partir del objeto encontrado, retorna "pzaRealizadas / pzaTeoricas"
    ratioActual() {
      const h = this.horaActualData;
      return h
        ? `${h.pzaRealizadas} / ${h.pzaTeoricas}`
        : '—';  // o cadena vacía si no hay franja coincidente
    },
    horas() {
      const data = this.value ? this.value.horas : [];
      const horarios = data.map(item => `${item.desdeHora} - ${item.hastaHora}`);
      return horarios;
    },
    pzaRealizadas() {
      const data = this.value ? this.value.horas : [];
      return data.map(h => h.pzaRealizadas)
    },
    pzaFaltantes() {
      const data = this.value ? this.value.horas : [];
      return data.map(h => {
        const teoricoProm = (h.pzaTeoricas + h.pzaTeoricasIzq) / 2;
        const realProm = h.pzaRealizadas;
        return Math.max(0, teoricoProm - realProm);
      });
    },
    pzaRealizadasIzq() {
      const data = this.value ? this.value.horas : [];
      return data.map(h => h.pzaRealizadasIzq)
    },
    pzaFaltantesIzq() {
      const data = this.value?.horas || [];
      return data.map(h => {
        const teoricoProm = (h.pzaTeoricas + h.pzaTeoricasIzq) / 2;
        return Math.max(0, teoricoProm - h.pzaRealizadasIzq);
      });
    },
    pzaTeoricas() {
      const data = this.value ? this.value.horas : [];
      return data.map(h => (h.pzaTeoricas + h.pzaTeoricasIzq) / 2)
    },
    confGraficaPiezas() {
      return {
        chart: {
          type: 'bar',
          height: 350,
          stacked: true
        },
        stroke: {
          // 6 columnas con width 1; línea con width 4
          width: [1, 1, 1, 1, 1, 1, 15],
          curve: 'smooth',
          colors: ['#fff', '#fff', '#fff', '#fff', '#fff', '#fff', '#FEB019', '#FEB019']
        },
        dataLabels: {
          enabled: true,
          formatter: val => val
        },
        plotOptions: {
          bar: {
            horizontal: false
          }
        },
        xaxis: {
          categories: this.horas,
          // categories: [
          //   '07:00',
          //   'Sales Training',
          //   'Print advertising',
          //   'Catalogs',
          //   'Meetings',
          //   'Public relations'
          // ]
        },
        fill: {
          opacity: 1
        },
        colors: [
          // F15B46
          // FEB019
          // '#F15B46', // Q1 Budget
          '#008FFB', // Buenas derecha
          // '#008FFB', // Q1 Actual
          '#00E396', // Buenas Izquierda
          // '#FEB019', // Q2 Budget
          '#F15B46', // Malas Derecha
          // '#00E396', // Q2 Actual
          '#F15B46', // Malas Izquierda
          '#993981', // Faltantes Derecha
          '#993981', // Faltantes Izquierda
          '#FEB019'  // TEAM C
        ],
        yaxis: {
          labels: {
            formatter: val => val
          }
        },
        legend: {
          position: 'bottom',
          horizontalAlign: 'center'
        },
        tooltip: {
          shared: true,
          intersect: false
        }
      }
    },
    seriesGraficaPiezas() {
      // Genera malas aleatorias
      const malasFalsasDer = this.horas.map(() =>
        // Math.floor(Math.random() * 20) + 5
        0
      )
      const malasFalsasIzq = this.horas.map(() =>
        // Math.floor(Math.random() * 15) + 3
        0
      )

      // Calcula faltantes = teóricas – (buenas + malas)
      const faltantesDer = this.horas.map((h, i) =>
        0
        // Math.max(0, h.pzaTeoricas - (this.pzaRealizadas[i] + malasFalsasDer[i]))
      )
      const faltantesIzq = this.horas.map((h, i) =>
        0
        // Math.max(0, h.pzaTeoricasIzq - (this.pzaRealizadasIzq[i] + malasFalsasIzq[i]))
      )

      return [
        {
          name: 'Piezas Izquierda',
          group: 'budget',
          type: 'column',
          data: this.pzaRealizadasIzq
        },
        {
          name: 'Piezas Derecha',
          group: 'actual',
          type: 'column',
          data: this.pzaRealizadas
        },
        {
          name: 'Piezas Izquierda Malas',
          group: 'budget',
          type: 'column',
          data: malasFalsasIzq
        },
        {
          name: 'Piezas Derecha Malas',
          group: 'actual',
          type: 'column',
          data: malasFalsasDer
        },
        {
          name: 'Faltantes Izquierda',
          group: 'budget',
          type: 'column',
          data: this.pzaFaltantesIzq
        },
        {
          name: 'Faltantes Derecha',
          group: 'actual',
          type: 'column',
          data: this.pzaFaltantes
        },
        {
          name: 'Esperado',
          type: 'line',
          data: this.pzaTeoricas
        }
      ]
    },
    pastel() {
      const horas = this.value?.horas || [];
      if (horas.length === 0) return [];
      // tomo la hora según la pestaña activa
      const h = horas[this.tab];
      return [
        h.pzaRealizadas || 0,   // Buenas
        h.pzaRetrabajo || 0,   // Retrabajo
        h.pzaScrap || 0    // Scrap
      ];
    },
    pastelIzq() {
      const horas = this.value?.horas || [];
      if (horas.length === 0) return [];
      const h = horas[this.tab];
      return [
        h.pzaRealizadasIzq || 0,
        h.pzaRetrabajoIzq || 0,
        h.pzaScrapIzq || 0
      ];
    },
    pastelTotal() {
      const horas = this.value?.horas || [];
      if (horas.length === 0) return [];
      // sumar todas las horas, si quieres el total acumulado:
      const totalBuenas = horas.reduce((sum, h) => sum + (h.pzaRealizadas || 0), 0);
      const totalRetrabajo = horas.reduce((sum, h) => sum + (h.pzaRetrabajo || 0), 0);
      const totalScrap = horas.reduce((sum, h) => sum + (h.pzaScrap || 0), 0);
      return [totalBuenas, totalRetrabajo, totalScrap];
    },
  }
}
</script>